import React from 'react';
import { Button } from '@material-ui/core';
import { CSVDownloadIcon } from '../../../ofishadmin/views/LeftNav/SvgIcons';

const CSVFile = ({ handleExport }) => {
    return (
        <div>
            <Button
                style={{
                    textTransform: "capitalize",
                    color: "#ffffff",
                    fontSize: "11px",
                    fontWeight: "500",
                    padding: "6px 8px",
                }}
                variant='contained'
                color="primary"
                startIcon={<CSVDownloadIcon />}
                onClick={handleExport}
            >
             Export CSV
            </Button>
        </div>
    )
}

export default CSVFile